import { render, staticRenderFns } from "./DecisionSuggestion.vue?vue&type=template&id=f864e79c&scoped=true"
import script from "./DecisionSuggestion.vue?vue&type=script&lang=js"
export * from "./DecisionSuggestion.vue?vue&type=script&lang=js"
import style0 from "./DecisionSuggestion.vue?vue&type=style&index=0&id=f864e79c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f864e79c",
  null
  
)

export default component.exports